export default {
  nav: {
    play: 'プレイ',
    about: '概要',
    features: '特徴',
    tips: 'ヒント',
    faq: 'よくある質問'
  },
  hero: {
    title: 'モンスターサバイバーズ',
    subtitle: '究極の無料オンラインローグライクサバイバルゲーム',
    playButton: '今すぐプレイ',
    learnButton: 'もっと詳しく'
  },
  about: {
    title: 'モンスターサバイバーズについて',
    description1: 'モンスターサバイバーズは、果てしないモンスターの波と戦うエキサイティングなローグライクサバイバルゲームです。',
    description2: 'キャラクターを選び、能力をアップグレードし、どれだけ長く生き残れるか挑戦しましょう！',
    description3: 'ユニークな武器の組み合わせとキャラクターの成長システムにより、毎回のプレイが異なる体験を提供します。',
    description4: 'ブラウザで直接プレイ可能 - ダウンロード不要！'
  },
  features: {
    title: 'ゲームの特徴',
    characters: {
      title: 'ユニークなキャラクター',
      description: '複数のキャラクターから選択可能。それぞれが独自の特殊能力とプレイスタイルを持っています。'
    },
    weapons: {
      title: '武器の進化',
      description: '異なる武器やアイテムを組み合わせて、強力な進化版を作成できます。'
    },
    gameplay: {
      title: 'エンドレスアクション',
      description: '手続き的に生成されるレベルで、次々と強くなるモンスターの波に立ち向かいます。'
    }
  },
  tips: {
    title: 'ゲームプレイのヒント',
    tip1: {
      title: '移動をマスター',
      description: '攻撃しながら敵を引きつけ、機動性を活かした戦い方を習得しましょう。'
    },
    tip2: {
      title: 'ビルドを計画',
      description: 'キャラクターとプレイスタイルに合わせたアップグレードを選択しましょう。'
    },
    tip3: {
      title: '素早くレベルアップ',
      description: '難易度曲線に追いつくため、経験値ジェムを素早く収集しましょう。'
    }
  },
  faq: {
    title: 'よくある質問',
    q1: {
      question: 'モンスターサバイバーズは無料でプレイできますか？',
      answer: 'はい、モンスターサバイバーズはウェブブラウザで完全無料でプレイできます。ダウンロードやインストールは不要です！'
    },
    q2: {
      question: 'モンスターサバイバーズの遊び方は？',
      answer: 'WASDで移動、スペースで攻撃、Eキーで特殊能力を使用します。経験値を集めてレベルアップし、アップグレードを選んで強くなりましょう！'
    },
    q3: {
      question: 'モンスターサバイバーズの特徴は？',
      answer: 'モンスターサバイバーズは、ユニークなキャラクター成長システム、武器進化システム、手続き的に生成されるレベルを特徴としています。毎回のプレイが異なる体験を提供します！'
    }
  },
  newsletter: {
    title: '最新情報を受け取る',
    description: 'アップデート、ヒント、特別イベントの情報を受け取るためにニュースレターに登録しましょう！',
    placeholder: 'メールアドレスを入力',
    button: '登録'
  },
  related: {
    title: 'おすすめの類似ゲーム',
    description: 'これらの素晴らしいローグライクサバイバルゲームもチェックしてください！'
  },
  footer: {
    quickLinks: 'クイックリンク',
    social: 'フォローする',
    copyright: '© 2024 モンスターサバイバーズ. All rights reserved.'
  },
  reviews: {
    title: 'ゲームレビュー',
    rating: '評価',
    commentPlaceholder: 'ゲーム体験を共有してください...',
    submit: 'レビューを投稿',
    ratingRequired: '評価を選択してください'
  }
} 